import glamorous from 'glamorous';

export default glamorous.svg(props => ({
  height: props.size,
  alignSelf: 'center',
  verticalAlign: 'middle',
  width: 'auto',
  ':hover g': {
    fill: '#B68962',
    stroke: '#FAFAFA',
  },
}));



// WEBPACK FOOTER //
// ./src/app/components/styledSvg.jsx